var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookFbSocialIconBleu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #4970b6;\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Blue",
    className: "st0",
    d: "M108.2,87.4c2.3,0,4.1-1.9,4.1-4.1V16.8c0-2.3-1.9-4.1-4.1-4.1H41.8c-2.3,0-4.1,1.9-4.1,4.1v66.5c0,2.3,1.9,4.1,4.1,4.1h66.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "f",
    className: "st1",
    d: "M89.2,87.4v-28.9h9.7l1.4-11.3h-11.2v-7.2c0-3.3.9-5.5,5.6-5.5h6v-10.1c-1-.1-4.6-.4-8.7-.4-8.6,0-14.5,5.2-14.5,14.9v8.3h-9.7v11.3h9.7v28.9h11.6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookFbSocialIconBleu);
export default __webpack_public_path__ + "static/media/facebook-fb-social-icon_bleu.f4681be79b361b5c5ba718e2ca51f5d4.svg";
export { ForwardRef as ReactComponent };